const data = require(`./data_${process.env.REACT_APP_BUILD_UID}/cars.json`)
const cars = [...data]

export default cars